/* eslint-disable sonarjs/no-duplicate-string */
import {useMutation, UseMutationOptions, UseMutationResult} from '@tanstack/react-query';

import {fetchCompetitorsTable, fetchExportCompetitors, fetchSummary} from './competitors-page-api';
import {CompetitorsTableResponseType, ExportExcelType, SummaryType} from './competitors-page-type';

export function useCompetitorsTable(): UseMutationResult<
    CompetitorsTableResponseType,
    unknown,
    {
        filterKey?: string | null;
        date: string;
        sortBy?: string;
        sortOrder?: 'asc' | 'desc';
        page: number;
        pageSize: number;
    }
> {
    return useMutation(['fetch-competitors-table'], (options) => {
        return fetchCompetitorsTable(options);
    });
}

export function useSummaryStats(): UseMutationResult<
    SummaryType,
    unknown,
    {
        filterKey?: string;
        currentDate: string;
        comparedDate: string;
    }
> {
    return useMutation(['fetch-summary-stats'], (options) => {
        return fetchSummary(options);
    });
}

export function useExportCompetitors(
    options?: UseMutationOptions<unknown, unknown, ExportExcelType>
): UseMutationResult<unknown, unknown, ExportExcelType> {
    return useMutation(
        ['export-competitors'],
        (parameters: ExportExcelType) => fetchExportCompetitors(parameters),
        options
    );
}
